// postfix JE - jQuery Element
(function () {
	const brandImages = () => {
		$(document).ready(function () {
            $(".js-get-brands").each(function (index, parent) {
                let parentId = `#${$(parent).attr("id")}`;

                let brandsSlider = document
                    .querySelector(parentId)
                    .querySelector(".js-swiper-brands");

                let brandsSliderNext = document
                    .querySelector(parentId)
                    .querySelector(".js-brands-arrow-prev");

                let brandsSliderPrev = document
                    .querySelector(parentId)
                    .querySelector(".js-brands-arrow-next");

                let brandsSliderScrollBar = document
                    .querySelector(parentId)
                    .querySelector(".js-brands-swiper-scrollbar");

                if (!brandsSlider) return;

                const BrandsSlider = new Swiper(brandsSlider, {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 12,
                    speed: 800,

                    navigation: {
                        prevEl: brandsSliderPrev,
                        nextEl: brandsSliderNext,
                    },

                    scrollbar: {
                        el: brandsSliderScrollBar,
                        draggable: true,
                    },

                    breakpoints: {
                        0: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                        },

                        576: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                        },

                        920: {
                            slidesPerView: 5,
                            slidesPerGroup: 5,
                        },

                        1200: {
                            slidesPerView: 6,
                            slidesPerGroup: 6,
                        },
                    },
                });
            });
        });
	}
    
    //.js-swiper-product-carousel
	document.addEventListener("DOMContentLoaded", function () {
		brandImages();
		document.addEventListener("shopify:section:load", function () {
			brandImages();
		});
	});

	window.addEventListener("resize", function () {
		brandImages();
	});
})();